export default __webpack_public_path__ + "static/media/apple_playstore_icon.033783d2.png";